import React from "react";
import { Link } from "react-router-dom";

const Notfound = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-purple-600 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-6">Page Not Found</p>
        <Link
          to="/home"
          className="text-white bg-purple-500 px-4 py-2 rounded hover:bg-purple-600"
        >
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default Notfound;
